// SEO domains: bought by name in Cloudflare Registrar, a public PWA on the
// root (api/cloudflare/src/lib/seo-domains.ts). Super admin only.
import api from './client';

export type SeoDomainState = 'registering' | 'registered' | 'zone' | 'attached' | 'ready' | 'failed';
export type SeoTargetKind = 'pwa' | 'tracker';

export interface SeoDomain {
  id: number;
  hostname: string;
  state: SeoDomainState;
  price: string | null;
  renewal_price: string | null;
  currency: string | null;
  expires_at: string | null;
  auto_renew: number | null;
  target_kind: SeoTargetKind | null;
  target_id: string | null;
  target_name: string | null;
  target_slug: string | null;
  seo_title: string | null;
  seo_description: string | null;
  error: string | null;
  created_at: number;
}

export interface SeoDomainsListing {
  domains: SeoDomain[];
  // Why nothing can be bought right now (no registrar token), or null.
  unavailable: string | null;
}

export interface SeoQuote {
  name: string;
  available: boolean;
  premium: boolean;
  price: string | null;
  renewal_price: string | null;
  currency: string | null;
  reason: string | null;
}

export interface SeoTargets {
  pwas: { id: string; name: string }[];
  campaigns: { id: string; name: string; slug: string; hostname: string }[];
}

export interface SeoTargetInput {
  target_kind: SeoTargetKind | null;
  target_id: string | null;
  seo_title: string | null;
  seo_description: string | null;
}

export const getSeoDomains = () => api.get<SeoDomainsListing>('/admin/seo-domains');
export const searchSeoDomains = (q: string) => api.get<SeoQuote[]>(`/admin/seo-domains/search?q=${encodeURIComponent(q)}`);
export const getSeoTargets = () => api.get<SeoTargets>('/admin/seo-domains/targets');
export const buySeoDomain = (hostname: string) => api.post<SeoDomainsListing>('/admin/seo-domains', { hostname });
export const retrySeoDomain = (id: number) => api.post<SeoDomainsListing>(`/admin/seo-domains/${id}/retry`);
export const updateSeoDomain = (id: number, input: SeoTargetInput) => api.put<SeoDomainsListing>(`/admin/seo-domains/${id}`, input);
export const deleteSeoDomain = (id: number) => api.delete<SeoDomainsListing>(`/admin/seo-domains/${id}`);
